export const PAGE_SEPARATOR_IDENTIFIER = '---'
export const INDIVIDUAL_SEPARATOR_IDENTIFIER = '@'
export const CATEGORY_INTERNAL_SEPERATOR = '~~/~~'
